import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ContentTypeInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const headersConfig = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        if ((req.method != "JSONP") && (req.url.indexOf('.json') === -1 && req.url.indexOf('copyright/infringement') === -1)) {
            const request = req.clone({
                setHeaders: headersConfig,
            });
            return next.handle(request);
        } else {
            return next.handle(req);
        }
    }
}
